import Vue from 'vue'
import VueRouter from 'vue-router'
import PublicHomeView from '@/views/PublicHomeView.vue'
import PrivateHomeView from '@/views/PrivateHomeView.vue'
import SetDetail from '@/views/sets/SetDetail.vue'
import SetList from '@/views/sets/SetList.vue'
import LoginView from '@/views/auth/LoginView.vue'
import ProfileView from '@/views/auth/ProfileView.vue'
import TuneList from '@/views/tunes/TuneList.vue'
import TuneDetail from '@/views/tunes/TuneDetail.vue'
import RecordingList from '@/views/recordings/RecordingList.vue'
import RecordingDetail from '@/views/recordings/RecordingDetail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: PrivateHomeView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfileView
  },
  {
    path: '/sets',
    name: 'set-list',
    component: SetList
  },
  {
    path: '/sets/:id',
    name: 'set-detail',
    component: SetDetail
  },
  {
    path: '/tunes',
    name: 'tune-list',
    component: TuneList
  },
  {
    path: '/tunes/:id',
    name: 'tune-detail',
    component: TuneDetail
  },
  {
    path: '/recordings',
    name: 'recording-list',
    component: RecordingList
  },
  {
    path: '/recordings/:id',
    name: 'recording-detail',
    component: RecordingDetail
  },
  {
    path: '/',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: PublicHomeView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/register', '/'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next('/login');
  } else {
    next();
  }
});

export default router
